var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('NavPage'),_c('IndexPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }